import React, { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useDialogCleanup } from '@/hooks/useDialogCleanup';

/**
 * Componente que limpia todos los diálogos cuando el usuario se desautentica
 * Debe estar dentro de ToastProvider para acceder a clearAllDialogs
 */
export const DialogCleanupWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { clearAllDialogs } = useDialogCleanup();
  const wasAuthenticated = useRef(isAuthenticated);

  useEffect(() => {
    // Si el usuario estaba autenticado y ahora no lo está, limpiar diálogos
    if (wasAuthenticated.current && !isAuthenticated) {
      console.log('🚪 Usuario desautenticado, limpiando diálogos...');
      clearAllDialogs();
    }

    // Actualizar el estado anterior
    wasAuthenticated.current = isAuthenticated;
  }, [isAuthenticated, clearAllDialogs]);

  return <>{children}</>;
};
